var collectionOldScreen = $(window).width();
var collectionRtime;
var collectionTimeout = false;
var collectionDelta = 200;
$(window).resize(function () {
    collectionRtime = new Date();
    if (collectionTimeout === false) {
        collectionTimeout = true;
        setTimeout(resizeend, collectionDelta);
    }
});
function resizeend() {
    if (new Date() - collectionRtime < collectionDelta) {
        setTimeout(resizeend, collectionDelta);
    } else {
        collectionTimeout = false;
        if ($(window).width() > 767 && collectionOldScreen < 768) {
            // MB -> PC
        } else if ($(window).width() < 768 && collectionOldScreen > 767) {
            // PC -> MB
        }
        collectionOldScreen = $(window).width();
        if (window.innerWidth < 1024) {
            const spacing = document.querySelector('.quick-links-menu-container') === null ? 0 : document.querySelector('.quick-links-menu-container').clientHeight;
            headerCollectionStop = (document.querySelector('.shopify-section--main-collection').offsetTop + spacing - headerCollection.clientHeight);
        } else {
            headerCollectionStop = (document.querySelector('.shopify-section--main-collection').offsetTop - headerCollection.clientHeight);
        }
        collectionToolbar = document.querySelector('height-observer[variable="collection-toolbar"]');
        collectionToolbarShadow = document.querySelector('.height-observer-shadow');
        collectionToolbarShadow.style.height = collectionToolbar.clientHeight + 'px';
        stickyFilerBar();
        filterStickDetect();
        const filterBtn = document.querySelector('.collection-toolbar__button--filter');
        const filtersWrap = document.querySelector('.filters_wrap');
        const filters = document.querySelectorAll('.products_filter');
        const filtersNr = document.querySelectorAll('.filters_nr');
        const gr1Checkboxes = document.querySelectorAll('.products_filter[name="filter_1"]');
        const gr2Checkboxes = document.querySelectorAll('.products_filter[name="filter_2"]');
        const gr3Checkboxes = document.querySelectorAll('.products_filter[name="filter_3"]');
        const singleFiltersNr = document.querySelectorAll('.filters_wrap .single_filters_nr');
        const coffeeFilters = document.querySelectorAll('.coffee_selector_filter');
        const products = document.querySelectorAll('.collection__main product-card.product-card');
        if (!filterBtn && !filtersWrap && !filters.length) {
            return;
        } else {
            if (Array.from(coffeeFilters).filter(checkbox => checkbox.checked).length)
                resetFilters(true);

            const filteredProducts = filterElements(gr1Checkboxes, gr2Checkboxes, gr3Checkboxes, products, filtersNr, singleFiltersNr, coffeeFilters);
            orderPromotionBlock(filteredProducts);
            setTimeout(() => {
                stickyElementNextOffsetTop = stickyElementNext.offsetTop;
                filterStickDetect();
            }, 800);
        }
    }
}
////PRODUCT FILTERS////
function productsFiltersInit(products) {
    const filterBtn = document.querySelector('.collection-toolbar__button--filter');
    const filtersWrap = document.querySelector('.filters_wrap');
    const filters = document.querySelectorAll('.products_filter');
    const clearFilterBtns = document.querySelectorAll('.clear_filter_btn');
    const filtersNr = document.querySelectorAll('.filters_nr');
    const gr1Checkboxes = document.querySelectorAll('.products_filter[name="filter_1"]');
    const gr2Checkboxes = document.querySelectorAll('.products_filter[name="filter_2"]');
    const gr3Checkboxes = document.querySelectorAll('.products_filter[name="filter_3"]');
    const filtersAcc = document.querySelectorAll('.filters_wrap .filter_header');
    const closeFiltersBtns = document.querySelectorAll('.close_filters_js');
    const clearAllFiltersXs = document.querySelector('.clear_all_filters_xs');
    const singleFiltersNr = document.querySelectorAll('.filters_wrap .single_filters_nr');
    const coffeeFilters = document.querySelectorAll('.coffee_selector_filter');

    if (!filterBtn && !filtersWrap && !filters.length) return;

    filterBtn.addEventListener('click', () => {
        let delay = 0;
        if (window.innerWidth > 767) {
            // const scrollToFilter = setInterval(() => {
            //     const scrollToProductList = () => document.querySelector(".shopify-section--main-collection").scrollIntoView(true);
            //     if ("requestIdleCallback" in window) {
            //         requestIdleCallback(scrollToProductList);
            //     } else {
            //         requestAnimationFrame(scrollToProductList);
            //     }
            // }, 10);
            // setTimeout(() => { clearInterval(scrollToFilter); }, 1200);
            if (filterBtn.classList.contains('active')) {
                filterBtn.classList.remove('active');
                filterBtn.setAttribute('aria-expanded', 'false');
                gsap.to(filtersWrap, {
                    display: 'none',
                    opacity: 0,
                    maxHeight: 0,
                    duration: 0.5,
                    ease: 'power2.inOut'
                });
                document.documentElement.classList.remove('filter-open');
            } else {
                filterBtn.classList.add('active');
                filterBtn.setAttribute('aria-expanded', 'true');
                // if (hideCoffeeSelector()) delay = 0.8;
                gsap.to(filtersWrap, {
                    display: 'block',
                    opacity: 1,
                    maxHeight: 2000,
                    duration: 0.5,
                    delay: delay,
                    ease: 'power2.inOut'
                });
                document.documentElement.classList.add('filter-open');
            }
        } else {
            gsap.to(filtersWrap, {
                display: 'block',
                opacity: 1,
                duration: 0.5,
                ease: 'power2.inOut'
            });
            document.documentElement.classList.add('filter-open');
        }
    });

    for (const filter of filters) {
        filter.addEventListener('change', () => {
            if (Array.from(coffeeFilters).filter(checkbox => checkbox.checked).length)
                resetFilters(true);

            const filteredProducts = filterElements(gr1Checkboxes, gr2Checkboxes, gr3Checkboxes, products, filtersNr, singleFiltersNr, coffeeFilters);
            orderPromotionBlock(filteredProducts);
            setTimeout(() => {
                stickyElementNextOffsetTop = stickyElementNext.offsetTop;
                filterStickDetect();
            }, 800);
        });
    }


    for (const btn of clearFilterBtns) {
        btn.addEventListener('click', () => {
            resetFilters();
            const products = document.querySelectorAll('.collection__main product-card.product-card');
            orderPromotionBlock(products);
        });
    }


    for (const btn of closeFiltersBtns) {
        btn.addEventListener('click', () => {
            gsap.to(filtersWrap, {
                display: 'none',
                opacity: 0,
                duration: 0.5,
                ease: 'power2.inOut'
            });
            document.documentElement.classList.remove('coffee-selector-open');
            filterBtn.setAttribute('aria-expanded', 'false');
        });
    }

    if (window.innerWidth < 768) {
        for (const acc of filtersAcc) {
            const accContent = acc.nextElementSibling;
            acc.addEventListener('click', () => {
                if (acc.classList.contains('active')) {
                    acc.classList.remove('active');
                    gsap.to(accContent, {
                        display: 'none',
                        opacity: 0,
                        maxHeight: 0,
                        duration: 0.5,
                        ease: 'power2.inOut',
                        onComplete: () => {
                            accContent.classList.remove('active');
                        }
                    });
                } else {
                    acc.classList.add('active');
                    gsap.to(accContent, {
                        display: 'block',
                        opacity: 1,
                        maxHeight: 195,
                        duration: 0.5,
                        ease: 'power2.inOut',
                        onComplete: () => {
                            accContent.classList.add('active');
                        }
                    });
                }
            });
        }
    }
    // window.addEventListener('resize', () => {
    //     if(Array.from(coffeeFilters).filter(checkbox => checkbox.checked).length)
    //         resetFilters(true);

    //     const filteredProducts = filterElements(gr1Checkboxes, gr2Checkboxes, gr3Checkboxes, products, filtersNr, singleFiltersNr, coffeeFilters);
    //     orderPromotionBlock(filteredProducts);
    //     setTimeout(() => {
    //         stickyElementNextOffsetTop = stickyElementNext.offsetTop;
    //         filterStickDetect();
    //     }, 800);
    // });
}

function filterList(activeFilters, itemList) {
    if (!itemList.length) return;

    for (const item of itemList) {
        let showItem = true;
        const itemTags = item.dataset.tags.split(',');
        if (showItem) {
            item.classList.remove('hidden');
            gsap.to(item, {
                display: 'grid',
                opacity: 1,
                duration: 0.4,
                ease: 'power2.inOut'
            });
        } else {
            ``
            item.classList.add('hidden');
            gsap.to(item, {
                display: 'none',
                opacity: 0,
                duration: 0.4,
                ease: 'power2.inOut'
            });
        }
    };
}

function handleFilters(products, gr1Values, gr2Values, gr3Values) {
    return Array.from(products).filter(product => {
        const tags = product.dataset.tags.split(',');
        const matchesGroup1 = tags.filter(item => gr1Values.includes(item));
        const matchesGroup2 = tags.filter(item => gr2Values.includes(item));
        const matchesGroup3 = tags.filter(item => gr3Values.includes(item));
        const matches12Groups = [matchesGroup1, matchesGroup2].every(group => group.length > 0);
        const matches13Groups = [matchesGroup1, matchesGroup3].every(group => group.length > 0);
        const matches23Groups = [matchesGroup2, matchesGroup3].every(group => group.length > 0);
        const matchesAllGroups = [matchesGroup1, matchesGroup2, matchesGroup3].every(group => group.length > 0);
        let showItem = true;

        if (gr1Values.length && !matchesGroup1.length) {
            // The tags do not belong to group 1
            showItem = false;
        }

        if (gr2Values.length && !matchesGroup2.length) {
            // The tags do not belong to group 2
            showItem = false;
        }

        if (gr3Values.length && !matchesGroup3.length) {
            // The tags do not belong to group 3
            showItem = false;
        }

        if (gr1Values.length && gr2Values.length && !gr3Values.length && !matches12Groups) {
            // The tags do not belong to group 1 and 2
            showItem = false;
        }

        if (gr1Values.length && !gr2Values.length && gr3Values.length && !matches13Groups) {
            // The tags do not belong to group 1 and 3
            showItem = false;
        }

        if (!gr1Values.length && gr2Values.length && gr3Values.length && !matches23Groups) {
            // The tags do not belong to group 2 and 3
            showItem = false;
        }

        if (gr1Values.length && gr2Values.length && gr3Values.length && !matchesAllGroups) {
            // The tags do not belong to evry group
            showItem = false;
        }

        toggleShowItem(product, showItem);

        return showItem;
    });
}

function filterElements(gr1, gr2, gr3, products, viewItemsNr = [], filtersHeaders = [], coffeeFilters = []) {
    const gr1Values = Array.from(gr1)
        .filter(checkbox => checkbox.checked)
        .map(checkbox => checkbox.value);

    const gr2Values = Array.from(gr2)
        .filter(checkbox => checkbox.checked)
        .map(checkbox => checkbox.value);

    const gr3Values = Array.from(gr3)
        .filter(checkbox => checkbox.checked)
        .map(checkbox => checkbox.value);

    const filteredProducts = handleFilters(products, gr1Values, gr2Values, gr3Values);

    if (window.innerWidth > 767) {
        for (const item of viewItemsNr) {
            if (gr1Values.length + gr2Values.length + gr3Values.length > 0) {
                item.classList.add('active');
                item.innerHTML = `(${gr1Values.length + gr2Values.length + gr3Values.length})`;
            } else {
                item.classList.remove('active');
                item.innerHTML = '';
            }
        }
    } else {
        for (const item of viewItemsNr) {
            if (gr1Values.length + gr2Values.length + gr3Values.length > 0) {
                item.classList.add('active');
                item.innerHTML = `(${filteredProducts.length})`;
            } else {
                item.classList.remove('active');
                item.innerHTML = '';
            }
        }

        if (filtersHeaders[0]) {
            filtersHeaders[0].innerHTML = gr1Values.length ? `(${gr1Values.length})` : '';
        }
        if (filtersHeaders[1]) {
            filtersHeaders[1].innerHTML = gr2Values.length ? `(${gr2Values.length})` : '';
        }
        if (filtersHeaders[2]) {
            filtersHeaders[2].innerHTML = gr3Values.length ? `(${gr3Values.length})` : '';
        }
    }

    emptyStateToggle(filteredProducts);

    return filteredProducts;
}

function coffeeFilterElements(gr1, gr2, gr3, products, viewItemsWrap, viewItemsNr, filtersWrap, filters) {
    document.body.classList.add('coffee-filter-applied');
    const gr1Values = Array.from(gr1)
        .filter(checkbox => checkbox.checked)
        .map(checkbox => checkbox.value);

    const gr2Values = Array.from(gr2)
        .filter(checkbox => checkbox.checked)
        .map(checkbox => checkbox.value);

    const gr3Values = Array.from(gr3)
        .filter(checkbox => checkbox.checked)
        .map(checkbox => checkbox.value);

    if (filtersWrap[0]) {
        if (gr1Values.length) {
            filtersWrap[0].classList.add('active');
            filtersWrap[0].querySelector('.single_coffee_selector_header--selected').innerText = filtersWrap[0].querySelector('input[value="' + gr1Values[0] + '"]').getAttribute('data-label');
        } else {
            filtersWrap[0].classList.remove('active');
            filtersWrap[0].querySelector('.single_coffee_selector_header--selected').innerText = '';
        }
    }

    if (filtersWrap[1]) {
        if (gr2Values.length) {
            filtersWrap[1].classList.add('active');
            filtersWrap[1].querySelector('.single_coffee_selector_header--selected').innerText = filtersWrap[1].querySelector('input[value="' + gr2Values[0] + '"]').getAttribute('data-label');
        } else {
            filtersWrap[1].classList.remove('active');
            filtersWrap[1].querySelector('.single_coffee_selector_header--selected').innerText = '';
        }
    }

    if (filtersWrap[2]) {
        if (gr3Values.length) {
            filtersWrap[2].classList.add('active');
            filtersWrap[2].querySelector('.single_coffee_selector_header--selected').innerText = filtersWrap[2].querySelector('input[value="' + gr3Values[0] + '"]').getAttribute('data-label');
        } else {
            filtersWrap[2].classList.remove('active');
            filtersWrap[2].querySelector('.single_coffee_selector_header--selected').innerText = '';
        }
    }

    const filteredProducts = handleFilters(products, gr1Values, gr2Values, gr3Values);
    if (gr1Values.length || gr2Values.length || gr3Values.length) {
        if (viewItemsWrap) {
            gsap.to(viewItemsWrap, {
                display: 'flex',
                opacity: 1
            });
        }
    } else {
        if (viewItemsWrap) {
            gsap.to(viewItemsWrap, {
                display: 'none',
                opacity: 0
            });
        }
    }

    for (const item of viewItemsNr) {
        item.innerHTML = `(${filteredProducts.length})`;
    }

    emptyStateToggle(filteredProducts);

    return filteredProducts;
}

function orderPromotionBlock(products) {
    // orderPostion
    let collection_promo = document.querySelector('.collection-promo');
    if (null == collection_promo) return;
    let counter = 0;
    let pos = orderPostion;
    let orderedLayout = false;
    if (null != collectionDescription) {
        counter++;
    }
    for (const product of products) {
        let itemPerRow = 3;
        if (window.innerWidth > 1280) {
            itemPerRow = 3;
            // pos = orderPostion;
            if (counter == (1 + (pos - 1) * itemPerRow)) {
                product.parentNode.insertBefore(collection_promo, product);
                orderedLayout = true;
                break;
            };
        } else if (window.innerWidth > 699) {
            itemPerRow = 2;
            pos = orderPostion;
            if (counter == (pos - 1) * itemPerRow) {
                product.parentNode.insertBefore(collection_promo, product);
                orderedLayout = true;
                break;
            };
        } else {
            itemPerRow = 1;
            pos = orderPostionMB;
            if (counter == (pos - 1) * itemPerRow) {
                product.parentNode.insertBefore(collection_promo, product);
                orderedLayout = true;
                break;
            };
        }
        counter++;
    }
    if (!orderedLayout) {
        products[products.length - 1].parentNode.appendChild(collection_promo);
    }
};

function emptyStateToggle(products, coffeeSelector = false) {
    const emptyState = document.querySelector('.EmptyState.grid');
    if (emptyState) {
        if (products.length) {
            gsap.to(emptyState, {
                display: 'none',
                opacity: 0,
                duration: 0.5,
                ease: 'power2.inOut'
            });
        } else {
            gsap.to(emptyState, {
                display: 'block',
                opacity: 1,
                duration: 0.5,
                ease: 'power2.inOut'
            });
        }
    }
}

function toggleShowItem(item, showItem, delay = 0) {
    if (showItem) {
        gsap.to(item, {
            display: 'grid',
            opacity: 1,
            duration: 0.5,
            delay: delay,
            y: 0,
            ease: 'power2.inOut'
        })
    } else {
        gsap.to(item, {
            display: 'none',
            opacity: 0,
            duration: 0.5,
            y: 50,
            ease: 'power2.inOut'
        })
    }
}

function resetFilters(coffeeSelector = false) {
    const emptyState = document.querySelector('.EmptyState.grid');
    const products = document.querySelectorAll('.collection__main product-card.product-card');
    const filtersNr = document.querySelectorAll('.filters_nr,.single_filters_nr');
    const filters = coffeeSelector ? document.querySelectorAll('.coffee_selector_filter') : document.querySelectorAll('.products_filter');
    const viewItemsWrap = document.querySelector('.coffee_selector_content .view_items_wrap');
    const coffeeHeaders = document.querySelectorAll('.single_coffee_selector_filter');

    document.body.classList.remove('coffee-filter-applied');

    for (const filter of filters) {
        if (filter.checked)
            filter.checked = false;
    }

    gsap.to(emptyState, {
        display: 'none',
        opacity: 0,
        duration: 0.5,
        ease: 'power2.inOut'
    });

    for (const product of products) {
        toggleShowItem(product, true);
    }

    for (const filterNr of filtersNr) {
        filterNr.innerHTML = '';
        filterNr.classList.remove('active');
    }

    if (coffeeSelector) {
        gsap.to(viewItemsWrap, {
            display: 'none',
            opacity: 0
        });

        for (const coffeeHeader of coffeeHeaders) {
            coffeeHeader.classList.remove('active');
        }
    }
    document.querySelectorAll('.single_coffee_selector_header--selected').forEach((item) => {
        item.innerText = '';
    });
    document.documentElement.classList.remove('coffee-selector-open');
}
function runCollectionFunctions() {
    let products = document.querySelectorAll('.collection__main product-card.product-card');
    orderPromotionBlock(products);
    ///filter products
    productsFiltersInit(products);
    ///emptyStateClear
    const emptyStateBtn = document.querySelector('.empty_state_btn');
    if (emptyStateBtn) {
        emptyStateBtn.addEventListener('click', () => {
            resetFilters(true);
            resetFilters(false);
        });
    }
    coffeeSelectorInit(products);
}
function filterStickDetect() {
    if (null === filterStickyElement) return;
    // Get the current scroll position
    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;

    // Check if the element is sticky
    if (scrollPosition >= filterStickyElementOffsetTop) {
        if (scrollPosition >= stickyElementNextOffsetTop - window.innerHeight / 2) {
            document.body.classList.remove('filter-pined');
        } else {
            document.body.classList.add('filter-pined');
        }
    } else {
        document.body.classList.remove('filter-pined');
    }

}
function hideFilters() {
    const filterBtn = document.querySelector('.collection-toolbar__button--filter');
    const filtersWrap = document.querySelector('.filters_wrap');
    let toHide = false;

    if (!filterBtn && !filtersWrap) return false;

    if (filterBtn.classList.contains('active')) {
        toHide = true;
        filterBtn.classList.remove('active');
        gsap.to(filtersWrap, {
            display: 'none',
            opacity: 0,
            maxHeight: 0,
            duration: 0.7,
            ease: 'power2.inOut'
        });
    }

    return toHide;
}
////END OF PRODUCT FILTERS////

////COFFE SELECTOR///
function getSiblings(elem, parentSlector) {
    let siblings = [];
    for (const sibling of elem.closest(parentSlector).children) {
        if (sibling !== elem) {
            siblings.push(sibling);
        }
    }

    return siblings;
}

function coffeeSelectorInit(products) {
    const coffeeSelectorWrap = document.querySelector('.coffee_selector_wrap');
    const coffeeSelectorBtn = document.querySelector('.coffee_selector_btn');
    const coffeeSelectorHeaders = document.querySelectorAll('.single_coffee_selector_header');
    const coffeeSelectorContents = document.querySelectorAll('.single_coffee_selector_content');
    const closeFiltersBtns = document.querySelectorAll('.close_filters_js');

    if (!coffeeSelectorWrap) return;

    if (coffeeSelectorBtn) {
        coffeeSelectorBtn.addEventListener('click', () => {
            if (window.innerWidth > 767) {
                let delay = 0;
                if (coffeeSelectorBtn.classList.contains('active')) {
                    coffeeSelectorBtn.classList.remove('active');
                    gsap.to(coffeeSelectorWrap, {
                        display: 'none',
                        opacity: 0,
                        maxHeight: 0,
                        duration: 0.5,
                        ease: 'power2.inOut'
                    });
                    document.documentElement.classList.remove('coffee-selector-open');
                } else {
                    coffeeSelectorBtn.classList.add('active');
                    if (hideFilters()) delay = 0.8;
                    gsap.to(coffeeSelectorWrap, {
                        display: 'block',
                        opacity: 1,
                        maxHeight: 2000,
                        duration: 1,
                        delay: delay,
                        ease: 'power2.inOut'
                    });
                    document.documentElement.classList.add('coffee-selector-open');
                }
            } else {
                gsap.to(coffeeSelectorWrap, {
                    display: 'block',
                    opacity: 1,
                    duration: 0.5,
                    ease: 'power2.inOut'
                });
                document.documentElement.classList.add('coffee-selector-open');
            }
        });
    }

    for (const btn of closeFiltersBtns) {
        btn.addEventListener('click', () => {
            if (btn.classList.contains('view_items')) {
                document.body.classList.add('coffee-filter-applied');
            } else {
                document.body.classList.remove('coffee-filter-applied');
            }
            if (window.innerWidth < 768) {
                gsap.to(coffeeSelectorWrap, {
                    display: 'none',
                    opacity: 0,
                    duration: 0.5,
                    ease: 'power2.inOut'
                });
                document.documentElement.classList.remove('coffee-selector-open');
            } else {
                gsap.to(coffeeSelectorWrap, {
                    display: 'none',
                    opacity: 0,
                    duration: 0.5,
                    ease: 'power2.inOut'
                });
                document.documentElement.classList.remove('coffee-selector-open');
                let buttonsFillter = document.querySelectorAll('.collection-toolbar .collection-toolbar__button-list button');
                console.log(buttonsFillter);
                [].forEach.call(buttonsFillter, el => {
                    el.classList.remove('active');
                });
                //document.querySelector('.coffee_selector_btn-container .button').click();
                document.querySelector(".shopify-section--main-collection").scrollIntoView(true);
            }
        });
    }


    coffeeSelectorHeaders.forEach((item, index) => {
        item.addEventListener('click', () => {
            if (item.classList.contains('active')) {
                item.classList.remove('active');
                gsap.to(coffeeSelectorContents[index], {
                    display: 'none',
                    opacity: 0,
                    maxHeight: 0,
                    duration: 0.5,
                    ease: 'power2.inOut',
                    onComplete: () => {
                        coffeeSelectorContents[index].classList.remove('active');
                    }
                });
            } else {
                const siblings = getSiblings(item.parentNode, '.coffee_selector_filters');

                for (const sibling of siblings) {
                    const siblingContent = sibling.querySelector('.single_coffee_selector_content');

                    if (sibling.querySelector('.single_coffee_selector_header')) {
                        sibling.querySelector('.single_coffee_selector_header').classList.remove('active');
                    }

                    if (siblingContent) {
                        gsap.to(siblingContent, {
                            display: 'none',
                            opacity: 0,
                            maxHeight: 0,
                            duration: 0.5,
                            ease: 'power2.inOut',
                            onComplete: () => {
                                siblingContent.classList.remove('active');
                            }
                        });
                    }
                }

                item.classList.add('active');
                gsap.to(coffeeSelectorContents[index], {
                    display: 'block',
                    opacity: 1,
                    maxHeight: 162,
                    duration: 0.5,
                    ease: 'power2.inOut',
                    onComplete: () => {
                        coffeeSelectorContents[index].classList.add('active');
                    }
                });
            }
        });
    });

    ///filters
    coffeeSelectorFilters(products);
}


function coffeeSelectorFilters(products) {
    const filtersWrap = document.querySelectorAll('.single_coffee_selector_filter');
    const filters = document.querySelectorAll('.products_filter');
    const coffeeFilters = document.querySelectorAll('.coffee_selector_filter');
    const gr1Checkboxes = document.querySelectorAll('.coffee_selector_filter[name="coffee_filter_1"]');
    const gr2Checkboxes = document.querySelectorAll('.coffee_selector_filter[name="coffee_filter_2"]');
    const gr3Checkboxes = document.querySelectorAll('.coffee_selector_filter[name="coffee_filter_3"]');
    const viewItemsWrap = document.querySelector('.coffee_selector_wrap .view_items_wrap');
    const viewItemsNr = document.querySelectorAll('.coffee_selector_wrap .coffee_selector_nr');


    for (const item of coffeeFilters) {
        item.addEventListener('change', () => {
            if (Array.from(filters).filter(checkbox => checkbox.checked).length)
                resetFilters(false);

            const filteredProducts = coffeeFilterElements(
                gr1Checkboxes,
                gr2Checkboxes,
                gr3Checkboxes,
                products,
                viewItemsWrap,
                viewItemsNr,
                filtersWrap,
                filters
            );
        });
    }

    if (viewItemsWrap) {
        const viewItemsBtn = viewItemsWrap.querySelector('.view_items');
        const viewItemsBtnClear = viewItemsWrap.querySelector('.coffee_selector_clear');

        // if (window.innerWidth > 767 && viewItemsBtn) {
        //     viewItemsBtn.addEventListener('click', () => {
        //         // smoothScroll('.products_list', 1000, 60);
        //         console.log('scroll to view');
        //     });
        // }

        if (viewItemsBtnClear) {
            viewItemsBtnClear.addEventListener('click', () => {
                resetFilters(true);
            });
        }
    }
}
///END OF COFFE SELECTOR////

// Get a reference to your sticky element
const filterStickyElement = document.querySelector('.main-collection-wrap');
// const filterStickyElement = document.querySelector('.collection-toolbar');

// Store the initial offset top of the element
const filterStickyElementOffsetTop = filterStickyElement.offsetTop;

var stickyElementNext = document.querySelector('.shopify-section--footer');
var stickyElementNextOffsetTop = stickyElementNext.offsetTop;
let orderPostion = -1;
let orderPostionMB = -1;
const collectionDescription = document.querySelector('.collection-description');
if (null !== document.querySelector('.collection-promo')) {
    switch (document.querySelector('.collection-promo').getAttribute('data-position')) {
        case 'first':
            orderPostion = 1;
            break;
        case 'second':
            orderPostion = 2;
            break;
        case 'third':
            orderPostion = 3;
            break;
        case 'third':
            orderPostion = 4;
            break;
        default:
            orderPostion = -1;
    }
    switch (document.querySelector('.collection-promo').getAttribute('data-position-mb')) {
        case 'first':
            orderPostionMB = 1;
            break;
        case 'second':
            orderPostionMB = 2;
            break;
        case 'third':
            orderPostionMB = 3;
            break;
        case 'fourth':
            orderPostionMB = 4;
            break;
        default:
            orderPostionMB = -1;
    }
}
var headerCollection = document.querySelector('.shopify-section--header height-observer');
var footerCollection = document.querySelector('.shopify-section--footer');
var collectionToolbar = document.querySelector('height-observer[variable="collection-toolbar"]');
var collectionToolbarShadow = document.querySelector('.height-observer-shadow');
var headerCollectionStop = (document.querySelector('.shopify-section--main-collection').offsetTop - headerCollection.clientHeight);
var footerCollectionStop = (footerCollection.offsetTop - headerCollection.clientHeight - collectionToolbar.clientHeight);
if (window.innerWidth < 1024) {
    const spacing = document.querySelector('.quick-links-menu-container') === null ? 0 : document.querySelector('.quick-links-menu-container').clientHeight;
    headerCollectionStop = (document.querySelector('.shopify-section--main-collection').offsetTop + spacing - headerCollection.clientHeight);
}

function stickyFilerBar() {
    const scrollTop = (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
    // console.log(scrollTop, collectionToolbar.offsetTop);
    // collectionToolbar.offsetTop;

    if (scrollTop >= headerCollectionStop && scrollTop <= footerCollectionStop) {
        collectionToolbar.classList.add('sticky');
        document.body.classList.add('filter-pined');
        collectionToolbar.style.top = headerCollection.clientHeight + 'px';
    } else {
        collectionToolbar.classList.remove('sticky');
        document.body.classList.remove('filter-pined');
        collectionToolbar.style.top = 'initial';
    }
}

window.addEventListener('DOMContentLoaded', () => {
    if (window.innerWidth < 1024) {
        const spacing = document.querySelector('.quick-links-menu-container') === null ? 0 : document.querySelector('.quick-links-menu-container').clientHeight;
        headerCollectionStop = (document.querySelector('.shopify-section--main-collection').offsetTop + spacing - headerCollection.clientHeight);
    } else {
        headerCollectionStop = (document.querySelector('.shopify-section--main-collection').offsetTop - headerCollection.clientHeight);
    }
    collectionToolbar = document.querySelector('height-observer[variable="collection-toolbar"]');
    collectionToolbarShadow = document.querySelector('.height-observer-shadow');
    collectionToolbarShadow.style.height = collectionToolbar.clientHeight + 'px';

    runCollectionFunctions();

    document.addEventListener("theme:loading:end", () => {
        setTimeout(function () {
            runCollectionFunctions();
        }, 1000);
    });

    // Add an event listener for the scroll event
    window.addEventListener('scroll', (e) => {
        stickyFilerBar();
        filterStickDetect();
    });
    setCollectionScale();
});

function setCollectionScale() {
    document.querySelectorAll('.template-collection .product-card__figure').forEach(function (card) {
        let minWidth = parseInt(card.querySelector('a').offsetWidth);
        card.querySelectorAll('img').forEach(function (img) {
            if (parseInt(img.offsetWidth) < minWidth) {
                minWidth = parseInt(img.offsetWidth);
            }
        });
        if (0 === minWidth) {
            card.querySelector('a').style.maxWidth = 'initial';
        } else {
            card.querySelector('a').style.maxWidth = minWidth + 'px';
        }
    });
}